import {
  Activity,
  Info,
  Calculator,
  Compass,
  FileText,
  FolderOpen,
  Image,
  Settings,
  SquareTerminal,
} from "lucide-react";
import ExplorerApp from "./ExplorerApp";
import EdgeApp from "./EdgeApp";
import NotepadApp from "./NotepadApp";
import SettingsApp from "./SettingsApp";
import TerminalApp from "./TerminalApp";
import CalculatorApp from "./CalculatorApp";
import TaskManagerApp from "./TaskManagerApp";
import PhotosApp from "./PhotosApp";
import PropertiesApp from "./PropertiesApp";
import "./apps.css";

/**
 * Installed applications. Files declare which of these opens them (see fs.js),
 * the same way Windows keeps file associations.
 */
export const APPS = [
  {
    id: "explorer",
    title: "File Explorer",
    subtitle: "Browse this PC",
    icon: FolderOpen,
    color: "#e8a33d",
    component: ExplorerApp,
    width: 1020,
    height: 660,
    pinned: true,
  },
  {
    id: "edge",
    title: "Edge",
    subtitle: "Browse the web",
    icon: Compass,
    color: "#0f6cbd",
    component: EdgeApp,
    width: 1120,
    height: 740,
    pinned: true,
  },
  {
    id: "notepad",
    title: "Notepad",
    subtitle: "Text editor",
    icon: FileText,
    color: "#2f7fd4",
    component: NotepadApp,
    width: 780,
    height: 580,
    pinned: true,
  },
  {
    id: "settings",
    title: "Settings",
    subtitle: "Personalise this PC",
    icon: Settings,
    color: "#4a5b6b",
    component: SettingsApp,
    width: 1000,
    height: 680,
    pinned: true,
  },
  {
    id: "terminal",
    title: "Terminal",
    subtitle: "PowerShell",
    icon: SquareTerminal,
    color: "#3a3a3a",
    component: TerminalApp,
    width: 820,
    height: 540,
    pinned: true,
  },
  {
    id: "photos",
    title: "Photos",
    subtitle: "View pictures",
    icon: Image,
    color: "#8661c5",
    component: PhotosApp,
    width: 860,
    height: 620,
  },
  {
    id: "calculator",
    title: "Calculator",
    subtitle: "Standard",
    icon: Calculator,
    color: "#5b6b7d",
    component: CalculatorApp,
    width: 360,
    height: 540,
  },
  {
    id: "taskmgr",
    title: "Task Manager",
    subtitle: "Processes and performance",
    icon: Activity,
    color: "#6b7280",
    component: TaskManagerApp,
    width: 900,
    height: 620,
  },
  {
    id: "properties",
    title: "Properties",
    subtitle: "Item and system information",
    icon: Info,
    color: "#4a5b6b",
    component: PropertiesApp,
    width: 460,
    height: 620,
    hidden: true,
  },
];

export default APPS;
